module.exports = __webpack_public_path__ + "img/specials-multislider-chevy.e3efc846.png";